import { useState } from "react";
import { Menu, X, Cpu } from "lucide-react";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { label: "AWS Infra", href: "#aws-course" },
    { label: "AWS+DB Architect", href: "#combined-course" },
    { label: "Azure AZ-305", href: "#azure-course" },
    { label: "OCI Course", href: "#oci-course" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0A0F]/85 border-b border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <a href="#" className="flex items-center gap-2 font-['Space_Grotesk'] font-bold text-xl tracking-tight text-[#F4F4F5]">
          <Cpu size={22} className="text-[#22D3EE]" />
          OCI <span className="text-[#E32636]">Mastery</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              className="text-sm font-medium text-[#A1A1AA] hover:text-[#22D3EE] transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#enroll"
            data-testid="header-enroll-button"
            className="bg-[#E32636] hover:bg-[#FF2D3B] text-white text-sm font-semibold px-5 py-2 rounded-md transition-colors duration-200"
          >
            Enroll Now
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-[#A1A1AA]"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-[#111118] border-b border-[#27272A] px-4 pb-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block py-2 text-sm font-medium text-[#A1A1AA] hover:text-[#22D3EE]"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#enroll"
            onClick={() => setMobileOpen(false)}
            className="block mt-2 text-center bg-[#E32636] hover:bg-[#FF2D3B] text-white text-sm font-semibold px-5 py-2 rounded-md"
          >
            Enroll Now
          </a>
        </div>
      )}
    </header>
  );
}
